import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="bg-ink-900 px-5 py-14 sm:px-8 sm:py-20" data-id="element-281" data-mp="3mg0qcz4bbfl7">
      <div className="mx-auto max-w-5xl" data-id="element-282" data-mp="3r80uz4vbuwo4">
        <SectionHeading title="What Professionals Are Looking For" subtitle="A better way to organize TRT knowledge." data-id="element-283" data-mp="3r93m9dwkb14k" />

        <blockquote className="mx-auto mt-8 max-w-2xl rounded-2xl border-l-4 border-teal-400 bg-ink-800/70 p-5 sm:p-7" data-id="element-284" data-mp="42jebs4jwskx">
          <p className="text-base font-semibold leading-relaxed text-white sm:text-xl" data-id="element-285" data-mp="92xl76uf1whd">
            “I don’t need another place to store information. I need to find the information I need
            when I’m actually seeing a patient.”
          </p>
          <footer className="mt-3 text-[13px] leading-relaxed text-white/60 sm:text-sm" data-id="element-286" data-mp="2avlqdlqmetzs">
            That’s the philosophy behind the Master System of TRT™ — designed around the clinical
            workflow, not around simply accumulating pages of information.
          </footer>
        </blockquote>

        <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-287" data-mp="1nrzozardxwe1">
          {testimonials.map(item => <figure key={item.name} className="flex flex-col rounded-2xl border border-white/10 bg-ink-800/60 p-5" data-id="element-288" data-mp="1isdakxztma3n">
              <QuoteIcon className="h-5 w-5 text-teal-400" aria-hidden="true" data-id="element-289" data-mp="2bi3vbpvyka8q" />
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-white/85 sm:text-[15px]" data-id="element-290" data-mp="26k2b31msq4vo">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-white/10 pt-4" data-id="element-291" data-mp="1xjm9jxpm57tg">
                <img src={item.image} alt={item.name} className="h-12 w-12 shrink-0 rounded-full object-cover" width={96} height={96} data-id="element-292" data-mp="r3jzfeo9zn0x" />
                <div className="min-w-0" data-id="element-293" data-mp="nmnu85evbe6j">
                  <p className="text-sm font-bold text-white" data-id="element-294" data-mp="njjgohfij637">{item.name}</p>
                  <p className="text-[12px] leading-snug text-teal-200/80" data-id="element-295" data-mp="sk78v6fh9sz0">{item.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-296" data-mp="ilhwtua9j2qo">
          <CtaButton label="Get the Master System of TRT™" subLabel="Instant Access · One-Time Payment · USD 27" data-id="element-297" data-mp="4v4ss30hs86m" />
        </div>
      </div>
    </section>;
}